import styled from "styled-components";

export default styled.div`
    color: #fff;
    display: flex;
    flex-direction: column;
    gap: 6px;

    input {
        background: transparent;
        border: none;
        caret: block;
        font-family: var(--font-mono), monospace;
        font-size: 4.8rem;
        margin: 0;
        outline: none;
        padding: 0 6px;

        &::placeholder {
            color: #fff;
        }
    }

    span {
        cursor: default;
        font-family: var(--font-mono), monospace;
        font-size: .8rem;
        opacity: .6;
        padding: 0 12px;
        white-space: nowrap;

        i {
            background: #cccc;
            border-radius: 4px;
            padding: 2px 4px;
        }
    }
`;
